import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'normalize.css' // 引入 normalize.css
import 'element-ui/lib/theme-chalk/index.css'
// import '@/assets/styles/index.scss'
import api from '@/api/api'
import moment from 'moment'

// 挂载 API
Vue.prototype.$api = api
Vue.prototype.$moment = moment

Vue.config.productionTip = false
Vue.use(ElementUI)

// 挂载基础 URL
Vue.prototype.$baseUrl = process.env.VUE_APP_IMG_BASE_URL
Vue.prototype.$orgBaseUrl = process.env.VUE_APP_ORG_IMG_BASE_URL

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
